import script from "./Support.vue?vue&type=script&setup=true&lang=js"
export * from "./Support.vue?vue&type=script&setup=true&lang=js"

import "./Support.vue?vue&type=style&index=0&id=259d3805&lang=css"

const __exports__ = script;

export default __exports__